import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import { TextField, Button } from "@mui/material";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styles from "assets/jss/vivoleo-react-kit/views/GenerateReportScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { FlashOffTwoTone } from "@material-ui/icons";

const useStyles = makeStyles(styles);

export default function TimeFilter(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const redirect = "/addfinancerec";
  const defaultYear = new Date().getFullYear();
  const [updateBtnShow, setUpdateBtnShow] = useState(false);
  //const defaultFrom = new Date(defaultYear, 0, 1);
  const defaultFrom = "01/01/" + defaultYear;
  const defaultTo = "12/01/" + defaultYear;
  const [selectedFromDate, setSelectedFromDate] = useState(defaultFrom);
  const [selectedToDate, setSelectedToDate] = useState(defaultTo);
  console.log("categories:");

  const handleFromDate = (newDate) => {
    setSelectedFromDate(
      parseInt(newDate.getMonth() + 1) +
        "/" +
        newDate.getDate() +
        "/" +
        newDate.getFullYear()
    );

    console.log("selectedFromDate:" + selectedFromDate);
  };
  const handleToDate = (newDate) => {
    setSelectedToDate(
      parseInt(newDate.getMonth() + 1) +
        "/" +
        newDate.getDate() +
        "/" +
        newDate.getFullYear()
    );
    console.log("selectedToDate:" + selectedToDate);
  };

  const addReportPeroid = (inputFromDate, inputToDate) => {
    props.ItemReprotingPeriod(inputFromDate, inputToDate);
  };

  return (
    <div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={4}>
          Reporting Period: From{" "}
          <div className={classes.fontUnderline}>{selectedFromDate} </div> To{" "}
          <div className={classes.fontUnderline}>{selectedToDate}</div>
          <div className={classes.space30}> </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack sx={{ width: 300 }} spacing={{ xs: 4, sm: 4, md: 4 }}>
              <MobileDatePicker
                label="Period From: Date(MM/DD/YYYY)"
                inputFormat="MM/dd/yyyy"
                value={selectedFromDate}
                onChange={handleFromDate}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
          <div className={classes.space30}> </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={4}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack sx={{ width: 300 }} spacing={{ xs: 4, sm: 4, md: 4 }}>
              <MobileDatePicker
                label="Period To: Date(MM/DD/YYYY)"
                inputFormat="MM/dd/yyyy"
                value={selectedToDate}
                onChange={handleToDate}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
          <div className={classes.space30}> </div>

          <Button
            disabled={updateBtnShow}
            onClick={() => {
              addReportPeroid(selectedFromDate, selectedToDate);
            }}
            variant="outlined"
            size="small"
          >
            Add This Period To Report
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}
